
import { useState } from "react";
import { Box, Button } from "@mui/material";
import ActivePartner from "./ActivePartner";
import InactivePartner from "./InactivePartner";

export default function ActiveInactiveTab() {
    const [activeTab, setActiveTab] = useState("ActivePartner");
    return (
        <>
            <Box>
                <Box display="flex" justifyContent="center" gap={2} mb={2}>
                    <Button
                        variant={activeTab === "ActivePartner" ? "contained" : "outlined"}
                        onClick={() => setActiveTab("ActivePartner")}
                    >
                        Active Partner
                    </Button>


                    <Button
                        variant={activeTab === "InActivePartner" ? "contained" : "outlined"}
                        onClick={() => setActiveTab("InActivePartner")}
                    >
                        Inactive Partner
                    </Button>

                </Box>

                {activeTab === "ActivePartner" && <ActivePartner />}
                {activeTab === "InActivePartner" && <InactivePartner />}
            </Box>
        </>
    );
}


